var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { importRemote } from 'module-federation-import-remote';
import { lazy, Suspense, useRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
export var loadModuleFederationScript = function (_a) {
    var module = _a.module, remoteEntryFileName = _a.remoteEntryFileName, scope = _a.scope, url = _a.url;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, importRemote({
                    module: module,
                    remoteEntryFileName: remoteEntryFileName,
                    scope: scope,
                    url: url.replace(/\/$/, ''),
                })];
        });
    });
};
export var ModuleFederationAppLoader = function (_a) {
    var module = _a.module, remoteEntryFileName = _a.remoteEntryFileName, scope = _a.scope, url = _a.url, _b = _a.fallbackComponent, fallbackComponent = _b === void 0 ? _jsx(_Fragment, {}) : _b, _c = _a.enabled, enabled = _c === void 0 ? true : _c, _d = _a.branchNameSubdomain, branchNameSubdomain = _d === void 0 ? undefined : _d, _e = _a.errorBoundaryFallbackComponent, errorBoundaryFallbackComponent = _e === void 0 ? _jsx(_Fragment, {}) : _e, otherProps = __rest(_a, ["module", "remoteEntryFileName", "scope", "url", "fallbackComponent", "enabled", "branchNameSubdomain", "errorBoundaryFallbackComponent"]);
    var ModuleFederationApp = useRef(lazy(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, loadModuleFederationScript({
                    module: module,
                    remoteEntryFileName: remoteEntryFileName,
                    scope: scope,
                    url: url.replace(/\/$/, ''),
                })];
        });
    }); }));
    return (_jsx(_Fragment, { children: enabled && (_jsx(Suspense, __assign({ fallback: fallbackComponent }, { children: _jsx(ErrorBoundary, __assign({ onError: function (error) {
                    // This error boundary will stop the main app from crashing for sub-applications not deployed in a feature context.
                    // Local, dev (outside of a feature context), staging, and production will crash and display an error as expected when a subapp fails to load.
                    if (error.message.includes(remoteEntryFileName) && !!branchNameSubdomain) {
                        console.warn("Ignoring sub-app \"".concat(otherProps.appName, "\", error message: ").concat(error.message));
                    }
                    else {
                        throw error;
                    }
                }, fallback: _jsx(_Fragment, { children: errorBoundaryFallbackComponent }) }, { children: _jsx(ModuleFederationApp.current, __assign({}, otherProps)) })) }))) }));
};
//# sourceMappingURL=moduleFederationAppLoader.js.map